(function () {
  // Preis-Caption des Themes ausblenden (einmalig)
  try { var st=document.createElement('style');
    st.textContent='.product__tax{display:none!important}';
    document.head.appendChild(st); } catch(e){}

  var prod=null, vp=null, lastCartKey='';
  function fmt(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; }
  function form(){ return document.querySelector('form[action*="/cart/add"]'); }
  function curId(){ var f=form(); var i=f && f.querySelector('[name="id"]'); return i && i.value; }
  function loadProd(cb){
    if (vp) return cb && cb();
    fetch(location.pathname.split('?')[0] + '.js').then(function(r){return r.json();}).then(function(p){
      prod=p; vp={}; p.variants.forEach(function(v){ vp[v.id]=v.price; }); cb && cb();
    }).catch(function(){});
  }
  function shortTitle(id){
    var v=prod && prod.variants.filter(function(x){return String(x.id)===String(id);})[0];
    var t=v && (v.public_title||v.title)||''; return t.split(' · ')[0].split(' - ')[0].trim();
  }
  function badges(){
    document.querySelectorAll('.product-form__input label, fieldset label').forEach(function(l){
      if (l.dataset.spBadge) return;
      var t=(l.textContent||'').trim(), b=null;
      if (/^M\s*[·]/.test(t)) b='Beliebteste'; else if (/^L\s*[·]/.test(t)) b='Beste Wahl';
      if (b){ l.dataset.spBadge='1'; var s=document.createElement('span');
        s.textContent=b; s.style.cssText='display:block;font-size:10px;font-weight:700;color:#0E7A8A;margin-top:2px'; l.appendChild(s); }
    });
  }
  function pdpUpdate(){
    if (!vp) return;
    var id=curId(), p=vp[id]; if (p==null) return;
    var s=Math.round(p*0.3);
    var el=document.getElementById('sp-bundle-save');
    if (el){ var txt='Bei deiner Größe '+shortTitle(id)+' sparst du '+fmt(s)+' auf die zweite Matte.';
      if (el.textContent!==txt) el.textContent=txt; }
  }

  var busy=false;
  function cartUpsell(){
  /* ABGESCHALTET 2026-07-13: bewarb "2. Matte 30 % guenstiger" und widersprach
     dem neuen 2+1-GRATIS-Angebot (Shopify-Automatik). Backup: theme-fixes/. */
  return;

    var drawer=document.querySelector('cart-drawer'); if(!drawer||busy) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var mats=cart.items.filter(function(i){return (i.product_title||'').indexOf('Kühlmatte')>-1;});
      var qty=mats.reduce(function(n,i){return n+i.quantity;},0);
      var key=qty+'|'+(mats[0]?mats[0].variant_id:'');
      if (key===lastCartKey && drawer.querySelector('#sp-upsell')) return; // nichts geaendert
      lastCartKey=key;
      var old=drawer.querySelector('#sp-upsell'); if(old) old.remove();
      if (qty!==1) return;
      var line=mats[0], vid=line.variant_id, sv=Math.round(line.final_price*0.3);
      var host=drawer.querySelector('.drawer__footer,[class*="footer"]')||drawer.querySelector('.drawer__inner')||drawer;
      var box=document.createElement('div'); box.id='sp-upsell';
      box.style.cssText='margin:12px 0 0;padding:14px;border:1px solid #CDE9ED;border-radius:12px;background:#EAF7F9';
      box.innerHTML='<div style="font-weight:700;color:#0E7A8A;font-size:15px">Zweite Matte 30% günstiger?</div>'+
        '<div style="font-size:13px;color:#123B42;margin:3px 0 2px">Ideal für Auto, Balkon oder Schlafzimmer.</div>'+
        '<div style="font-size:13px;font-weight:600;color:#0E7A8A;margin-bottom:10px">Gleiche Größe hinzufügen und '+fmt(sv)+' sparen.</div>'+
        '<button type="button" id="sp-upbtn" style="width:100%;background:#159AAD;color:#fff;border:0;border-radius:40px;padding:11px;font-size:14px;font-weight:600;cursor:pointer">Zweite Matte hinzufügen</button>'+
        '<div style="font-size:11px;color:#44636b;text-align:center;margin-top:6px">Rabatt wird automatisch angewendet.</div>';
      // UNTER Zwischensumme und Checkout-Button anhaengen, nie davor (Checkout bleibt oberstes Element)
      host.appendChild(box);
      box.querySelector('#sp-upbtn').addEventListener('click', function(){
        busy=true; this.disabled=true; this.textContent='Wird hinzugefügt…';
        var sections=(drawer.getSectionsToRender?drawer.getSectionsToRender().map(function(s){return s.id;}):['cart-drawer','cart-icon-bubble']);
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:vid,quantity:1}],sections:sections,sections_url:window.location.pathname})})
          .then(function(r){return r.json();}).then(function(res){
            // Den Render-Weg des Themes benutzen statt drawer.innerHTML zu ersetzen:
            // renderContents haengt Overlay-Handler neu an und laesst alle Theme-Handler intakt.
            if(res.sections && typeof drawer.renderContents==='function'){ drawer.renderContents(res); }
            // Wie product-form.js Z.115: Leer-Zustand aufheben, sonst blendet
            // component-cart-drawer.css die Positionen aus (Warenkorb wirkt leer).
            if(drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            lastCartKey=''; busy=false; setTimeout(cartUpsell,400);
          }).catch(function(){ busy=false; lastCartKey=''; setTimeout(cartUpsell,400); });
      });
    }).catch(function(){});
  }

  // KEIN Polling mehr: Cart-Aenderungen ueber fetch-Hook erkennen (add/change/update),
  // dazu einmal beim Laden und beim Oeffnen des Drawers. So springt das DOM nicht
  // mehr unter dem Finger weg, waehrend der Warenkorb offen ist.
  var of=window.fetch;
  window.fetch=function(){
    var url=(arguments[0]&&arguments[0].url)||arguments[0];
    var p=of.apply(this,arguments);
    if (typeof url==='string' && /\/cart\/(add|change|update|clear)/.test(url)){
      p.then(function(){ setTimeout(cartUpsell,450); }).catch(function(){});
    }
    return p;
  };
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble,a[href="/cart"],.header__icon--cart')){
      setTimeout(cartUpsell,300);
    }
  }, true);

  function run(){ if (document.querySelector('.product-form__input, fieldset')){ badges(); loadProd(pdpUpdate); } cartUpsell(); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('change', function(){ setTimeout(function(){badges();pdpUpdate();},250); }, true);
})();

// Sommerpfote UX override: separate size and color in the sticky ATC.
(function () {
  var spProduct = null;
  var spObserver = null;
  var spStyleId = 'sp-sticky-variant-style';
  var spPdpStyleId = 'sp-pdp-conversion-style';
  var spDiagnosticsStarted = false;
  var spDiagnosticsSent = {};

  function optionValue(variant, index) {
    return (variant.options && variant.options[index]) || (index === 0 ? variant.option1 : variant.option2) || '';
  }

  function availableVariants() {
    return (spProduct && spProduct.variants ? spProduct.variants : []).filter(function (variant) {
      return variant.available !== false;
    });
  }

  function unique(values) {
    var result = [];
    values.forEach(function (value) {
      if (value && result.indexOf(value) === -1) result.push(value);
    });
    return result;
  }

  function currentVariant() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var id = form && form.querySelector('[name="id"]');
    return availableVariants().filter(function (variant) {
      return id && String(variant.id) === String(id.value);
    })[0] || availableVariants()[0];
  }

  function mainInput(name, value) {
    var inputs = document.querySelectorAll('[data-option-name]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-option-name') === name && inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  function syncMainForm(size, color) {
    var sizeInput = mainInput('Gr\u00f6\u00dfe', size);
    var colorInput = mainInput('Farbe', color);
    if (sizeInput && !sizeInput.checked) sizeInput.click();
    if (colorInput && !colorInput.checked) colorInput.click();
    setTimeout(render, 250);
  }

  function fill(select, values, selected) {
    select.innerHTML = '';
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    select.value = values.indexOf(selected) > -1 ? selected : (values[0] || '');
  }

  function addStyle() {
    // Sticky-Override entfernt 2026-07-12; native Vitals-Sticky rendert unveraendert.
    addPdpStyle();
  }

  function addPdpStyle() {
    if (document.getElementById(spPdpStyleId)) return;
    var style = document.createElement('style');
    style.id = spPdpStyleId;
    style.textContent = '#ProductInfo-template--31605949989213__main{color:#4a2d1f!important}' +
      '#ProductInfo-template--31605949989213__main>p.product__text.inline-richtext{display:none!important}' +
      '#ProductInfo-template--31605949989213__main .product__title h1{color:#432719!important;letter-spacing:0!important;line-height:1.08!important}' +
      '#ProductInfo-template--31605949989213__main .price .price-item{color:#c81f45!important;font-weight:900!important}' +
      '.sp-social-proof{display:flex!important;align-items:center!important;gap:10px!important;width:100%!important;margin:0 0 12px!important;padding:9px 14px!important;border-radius:8px!important;background:#f5eee9!important;color:#4a2d1f!important;font-size:14px!important;font-weight:800!important;line-height:1.25!important}' +
      '.sp-social-proof__faces{display:flex!important;align-items:center!important;min-width:48px!important}.sp-social-proof__face{display:grid!important;place-items:center!important;width:26px!important;height:26px!important;border-radius:999px!important;border:2px solid #fff!important;background:#d9eee9!important;color:#365b4f!important;font-size:11px!important;font-weight:900!important;box-shadow:0 1px 4px rgba(67,39,25,.15)!important}.sp-social-proof__face+.sp-social-proof__face{margin-left:-8px!important;background:#f5d6c8!important;color:#6b3a24!important}' +
      '.sp-benefit-copy{margin:12px 0 14px!important;padding-top:14px!important;border-top:1px solid #eadfd8!important;color:#4d4d4d!important;font-size:17px!important;line-height:1.35!important;font-weight:700!important}.sp-benefit-list{display:grid!important;gap:8px!important;margin:0 0 18px!important;padding:0!important;list-style:none!important}.sp-benefit-list li{display:flex!important;align-items:flex-start!important;gap:10px!important;color:#5b514c!important;font-size:16px!important;line-height:1.28!important}.sp-benefit-list li:before{content:\"\\2713\"!important;color:#f18a21!important;font-size:19px!important;font-weight:900!important;line-height:1!important;margin-top:1px!important}' +
      'variant-selects .product-form__input--pill{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:10px!important;margin:18px 0 14px!important;max-width:none!important}variant-selects .product-form__input--pill legend{grid-column:1/-1!important;margin:0 0 2px!important;color:#4a2d1f!important;font-size:16px!important;font-weight:900!important}variant-selects .product-form__input--pill input[type=radio]{position:absolute!important;opacity:0!important;pointer-events:none!important}variant-selects .product-form__input--pill input[type=radio]+label{position:relative!important;display:flex!important;flex-direction:column!important;justify-content:center!important;align-items:center!important;width:100%!important;min-height:78px!important;margin:0!important;padding:13px 11px!important;border:2px solid #4a2d1f!important;border-radius:8px!important;background:#fffaf6!important;color:#4a2d1f!important;text-align:center!important;font-size:17px!important;font-weight:900!important;line-height:1.06!important;box-shadow:none!important;letter-spacing:0!important;transition:background .16s ease,border-color .16s ease,color .16s ease,transform .16s ease!important}variant-selects .product-form__input--pill input[type=radio]+label span:not(.visually-hidden){color:#806f66!important;font-size:12px!important;font-weight:700!important;line-height:1.12!important;margin-top:4px!important}variant-selects .product-form__input--pill input[type=radio]+label[data-sp-badge] span:not(.visually-hidden):first-of-type{color:#0e7a8a!important;font-size:12px!important;font-weight:900!important;text-transform:none!important}variant-selects .product-form__input--pill input[type=radio]:checked+label{background:#123b42!important;border-color:#123b42!important;color:#fff!important;box-shadow:0 0 0 4px #d8e8e9!important}variant-selects .product-form__input--pill input[type=radio]:checked+label span:not(.visually-hidden){color:#d8eef0!important}variant-selects .product-form__input--pill input[type=radio]:checked+label:after{content:\"\\2713\"!important;position:absolute!important;right:8px!important;top:8px!important;width:24px!important;height:24px!important;border-radius:999px!important;background:#32b85a!important;color:#fff!important;display:grid!important;place-items:center!important;font-size:15px!important;font-weight:900!important;line-height:1!important}' +
      '.sp-demand-note{display:flex!important;align-items:center!important;gap:8px!important;margin:0 0 18px!important;padding:11px 13px!important;border:1px solid #ffd36b!important;border-radius:8px!important;background:#fff9e9!important;color:#4a2d1f!important;font-size:14px!important;font-weight:800!important;line-height:1.25!important}.sp-demand-note:before{content:\"\\26A0\"!important;color:#f0a000!important}' +
      'variant-selects .product-form__input--swatch{display:flex!important;align-items:flex-start!important;gap:13px!important;margin:18px 0 16px!important;flex-wrap:wrap!important}variant-selects .product-form__input--swatch legend{flex-basis:100%!important;margin:0 0 4px!important;color:#4a2d1f!important;font-size:16px!important;font-weight:900!important}variant-selects .swatch-input__label{position:relative!important;width:64px!important;height:82px!important;margin:0!important;display:flex!important;align-items:flex-start!important;justify-content:center!important;padding-top:0!important;overflow:visible!important}variant-selects .swatch-input__label .swatch{width:58px!important;height:58px!important;border-radius:999px!important;border:3px solid #fff!important;box-shadow:0 0 0 2px #4a2d1f,0 4px 12px rgba(67,39,25,.12)!important}variant-selects .swatch-input__label:after{content:attr(title)!important;position:absolute!important;left:50%!important;top:64px!important;transform:translateX(-50%)!important;color:#4a2d1f!important;font-size:12px!important;font-weight:900!important;text-transform:uppercase!important;letter-spacing:0!important}variant-selects .swatch-input__input:checked+.swatch-input__label:before{content:\"\\2713\"!important;position:absolute!important;right:4px!important;top:0!important;width:20px!important;height:20px!important;border-radius:999px!important;background:#32b85a!important;color:#fff!important;display:grid!important;place-items:center!important;font-size:12px!important;font-weight:900!important;z-index:2!important}' +
      '.sp-gift-box{border:1.5px dashed #6b3a24!important;border-radius:10px!important;background:#fffaf5!important;padding:16px!important;margin:16px 0 20px!important;color:#4a2d1f!important}.sp-gift-box:before{content:\"EXKLUSIVE GRATIS-GESCHENKE\"!important;display:block!important;margin:0 0 8px!important;color:#4a2d1f!important;font-size:14px!important;font-weight:900!important;letter-spacing:.03em!important}.sp-gift-box [style],.sp-gift-box span{letter-spacing:0!important}' +
      '@media(min-width:990px){#ProductInfo-template--31605949989213__main{background:#fff!important;border:1px solid #eadfd8!important;border-radius:12px!important;padding:22px 22px 24px!important;box-shadow:0 8px 28px rgba(67,39,25,.05)!important}}' +
      '@media(max-width:749px){.sp-social-proof{font-size:13px!important;padding:8px 10px!important;margin-bottom:10px!important}.sp-benefit-copy{font-size:15px!important}.sp-benefit-list li{font-size:14px!important}variant-selects .product-form__input--pill{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important}variant-selects .product-form__input--pill input[type=radio]+label{min-height:72px!important;padding:12px 8px!important;font-size:15px!important}variant-selects .product-form__input--pill input[type=radio]+label span:not(.visually-hidden){font-size:11px!important}.sp-demand-note{font-size:13px!important}.sp-gift-box{padding:14px 12px!important}}';
    document.head.appendChild(style);
  }

  function trackDiagnostic(name, payload) {
    // TikTok standard/custom events are intentionally disabled here.
    // The official Shopify TikTok app is the single event source.
  }

  function suppressNewsletterPopup() {
    if (window.innerWidth > 749 || location.pathname.indexOf('/products/') !== 0) return;
    var popups = document.querySelectorAll('.Vtl-Modal.Vtl-Popup, .vitals_popup');
    for (var i = 0; i < popups.length; i++) {
      var popup = popups[i];
      var text = (popup.innerText || popup.textContent || '').toLowerCase();
      if (text.indexOf('newsletter') === -1 && text.indexOf('registrieren') === -1) continue;
      popup.setAttribute('data-sp-suppressed', 'newsletter');
      popup.style.display = 'none';
      popup.style.visibility = 'hidden';
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('Vtl-Modal--Active');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      trackDiagnostic('SP_NewsletterPopup_Suppressed', {});
    }
  }

  function initDiagnostics() {
    if (spDiagnosticsStarted || location.pathname.indexOf('/products/') !== 0) return;
    spDiagnosticsStarted = true;
    setTimeout(function () { trackDiagnostic('SP_LP_5s_View', {}); }, 5000);
    [25, 50, 75, 90].forEach(function (depth) {
      window.addEventListener('scroll', function () {
        var maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        var percent = Math.round((window.scrollY / maxScroll) * 100);
        if (percent >= depth) trackDiagnostic('SP_Scroll_' + depth, { scroll_depth: depth });
      }, { passive: true });
    });
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target && target.closest)) return;
      if (target.closest('#bundle-sticky_submit')) trackDiagnostic('SP_Click_ATC_Sticky', {});
      if (target.closest('form[data-type="add-to-cart-form"] button[type="submit"]')) trackDiagnostic('SP_Click_ATC_Main', {});
    }, true);
  }

  function enhancePdp() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    addPdpStyle();
    var info = document.getElementById('ProductInfo-template--31605949989213__main');
    if (!info) return;

    var title = info.querySelector('.product__title');
    if (title && !info.querySelector('.sp-social-proof')) {
      var proof = document.createElement('div');
      proof.className = 'sp-social-proof';
      proof.innerHTML = '<span class="sp-social-proof__faces"><span class="sp-social-proof__face">P</span><span class="sp-social-proof__face">A</span></span><span>Petra, Andrea und 35+ Hundebesitzer sind begeistert</span>';
      info.insertBefore(proof, info.firstElementChild);
    } else {
      var existingProof = info.querySelector('.sp-social-proof');
      if (existingProof && info.firstElementChild !== existingProof) info.insertBefore(existingProof, info.firstElementChild);
    }

    if (!info.querySelector('.sp-benefit-copy')) {
      var anchor = info.querySelector('a[href="#shopify-section-loox_reviews"]');
      var copy = document.createElement('div');
      copy.className = 'sp-benefit-copy';
      copy.textContent = 'Hunde k\u00f6nnen nicht schwitzen. Sommerpfote k\u00fchlt sie in Minuten. Ohne Gel, ohne Strom.';
      var list = document.createElement('ul');
      list.className = 'sp-benefit-list';
      ['Perfekt f\u00fcr unterwegs', 'Gel-frei, ohne Schadstoffe', 'Sp\u00fcrbar k\u00fchler in Minuten', 'Einfach in die Waschmaschine'].forEach(function (text) {
        var item = document.createElement('li');
        item.textContent = text;
        list.appendChild(item);
      });
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(copy, anchor.nextSibling);
        copy.parentNode.insertBefore(list, copy.nextSibling);
      }
    }

    var variants = info.querySelector('variant-selects');
    var sizeField = variants && variants.querySelector('.product-form__input--pill');
    if (sizeField && !variants.querySelector('.sp-demand-note')) {
      var note = document.createElement('div');
      note.className = 'sp-demand-note';
      note.textContent = 'Diese Gr\u00f6\u00dfe und Farbe ist gerade besonders gefragt.';
      sizeField.parentNode.insertBefore(note, sizeField.nextSibling);
    }

    var giftCandidates = Array.prototype.slice.call(info.querySelectorAll('div')).filter(function (node) {
      var text = (node.innerText || node.textContent || '').replace(/\s+/g, ' ').trim();
      return text.indexOf('GRATIS ZU JEDER BESTELLUNG') !== -1;
    });
    giftCandidates.forEach(function (node) { node.classList.remove('sp-gift-box'); });
    var outerGift = giftCandidates.filter(function (node) {
      return !giftCandidates.some(function (other) { return other !== node && other.contains(node); });
    })[0];
    if (outerGift) outerGift.classList.add('sp-gift-box');
  }

  function render() {
    return; // Sticky-Split entfernt; nativer Vitals-Sticky uebernimmt.
  }

  function observe() {
    return; // Sticky-Observer entfernt; nativer Vitals-Sticky braucht keinen Split-Rebuild.
  }

  function init() {
    addStyle();
    enhancePdp();
    suppressNewsletterPopup();
    initDiagnostics();
    if (spProduct) { render(); observe(); return; }
    fetch(location.pathname.split('?')[0] + '.js').then(function (response) {
      return response.json();
    }).then(function (product) {
      spProduct = product;
      render();
      observe();
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(suppressNewsletterPopup, 700);
})();
